import { Component, Input, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ToolService } from '@app/core/services/tool/tool.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// returns true if ashleys name is in the application coach property
const coachAshley = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('ashley') !== -1;
};

// returns true if wanhs name is in the application coach property
const coachWanh = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('wanh') !== -1;
};

const coachMia = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('mia') !== -1;
};

const coachBrook = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('brook') !== -1;
};

const coachKelli = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('kelli') !== -1;
};

const coachMegha = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('megha') !== -1;
};

const coachJustin = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('justin') !== -1;
};

const coachChris = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('chris') !== -1;
};

const coachGrace = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('grace') !== -1;
};

const coachCaleb = (coach: string): boolean => {
    return coach.toLowerCase().indexOf('caleb') !== -1;
};

@Component({
    selector: 'app-advisor-list',
    templateUrl: './application-advisor-list.component.html',
    styleUrls: ['./application-advisor-list.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationAdvisorListComponent implements OnInit {
    amo: any = {};

    @Input() application: any;
    @Input() advisor: boolean;
    @Input() coach: boolean;
    constructor(public toolService: ToolService) {}

    async ngOnInit() {
        if (this.advisor) {
            this.amo.advisor = true;
            this.amo.ashley = false;
            this.amo.wanh = false;
            this.amo.mia = false;
            this.amo.kelli = false;
            this.amo.brook = false;
            this.amo.megha = false;
            this.amo.justin = false;
            this.amo.chris = false;
            this.amo.grace = false;
            this.amo.caleb = false;
        } else if ((this.application.madedeposit || this.application.madepayment || this.application.madefullpayment) && !this.application.coach) {
            this.amo.ashley = false;
            this.amo.wanh = false;
            this.amo.mia = false;
            this.amo.kelli = false;
            this.amo.brook = false;
            this.amo.megha = false;
            this.amo.justin = false;
            this.amo.chris = false;
            this.amo.grace = false;
            this.amo.caleb = false;
            this.amo.unassignedcoach = true;
        } else if (!this.application.coach && !this.application) {
            this.amo.advisor = true;
        } else if (this.application.coach.indexOf('test') !== -1) {
            this.amo.ashley = true;
        } else {
            this.amo.ashley = coachAshley(this.application.coach);
            this.amo.wanh = coachWanh(this.application.coach);
            this.amo.mia = coachMia(this.application.coach);
            this.amo.kelli = coachKelli(this.application.coach);
            this.amo.brook = coachBrook(this.application.coach);
            this.amo.megha = coachMegha(this.application.coach);
            this.amo.justin = coachJustin(this.application.coach);
            this.amo.chris = coachChris(this.application.coach);
            this.amo.grace = coachGrace(this.application.coach);
            this.amo.caleb = coachCaleb(this.application.coach);
        }
    }
}
